<template>
  <div class="login-card">
    <div class="login-card-header">
      <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
      <span>Nova senha</span>
    </div>
    <div class="login-card-body">
      <form @submit.prevent="onSubmit">
        <div class="alert alert-success" v-show="msg.success">
          <font-awesome-icon :icon="['fas', 'check-circle']"></font-awesome-icon>
          Senha alterada com sucesso. Você será levado ao login.
        </div>
        <div class="alert alert-danger" v-show="msg.error">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>
          {{ msg.error }}
        </div>

        <div v-if="!hasLink" class="alert alert-warning">
          Link inválido. Solicite uma nova recuperação de senha.
        </div>

        <div class="form-group">
          <label>E-mail</label>
          <input
            type="text"
            class="form-control"
            :value="email"
            disabled
          />
        </div>

        <div class="form-group">
          <label>Nova senha</label>
          <input
            type="password"
            class="form-control"
            v-model="password"
            placeholder="Mínimo de 8 caracteres"
            autocomplete="new-password"
            :disabled="!hasLink || msg.success"
            autofocus
          />
        </div>

        <div class="form-group">
          <label>Confirme a nova senha</label>
          <input
            type="password"
            class="form-control"
            v-model="passwordConfirmation"
            placeholder="Repita a senha"
            autocomplete="new-password"
            :disabled="!hasLink || msg.success"
          />
        </div>

        <div class="d-flex justify-content-between align-items-center mt-2">
          <button type="button" class="btn btn-sm btn-secondary" @click="goBack()">
            <font-awesome-icon :icon="['fa', 'arrow-left']"></font-awesome-icon>
            Voltar
          </button>
          <button
            type="submit"
            class="btn-login"
            :disabled="!hasLink || sending || msg.success"
          >
            <font-awesome-icon :icon="['fa', 'paper-plane']"></font-awesome-icon>
            Redefinir senha
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { computed, onBeforeUnmount, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import axios from 'axios'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()

      const token = computed(() => String(route.query.token || ''))
      const email = computed(() => String(route.query.email || ''))
      const hasLink = computed(() => token.value !== '' && email.value !== '')

      const password = ref('')
      const passwordConfirmation = ref('')
      const sending = ref(false)
      const msg = ref({
        success: false,
        error: '',
      })

      let redirectTimer = null

      const validate = () => {
        if (password.value.length < 8) {
          return 'A senha deve ter pelo menos 8 caracteres.'
        }
        if (password.value !== passwordConfirmation.value) {
          return 'A confirmação não confere com a nova senha.'
        }
        return ''
      }

      const onSubmit = () => {
        msg.value.error = ''

        const problem = validate()
        if (problem) {
          msg.value.error = problem
          return
        }

        sending.value = true

        axios
          .post('api/resetPassword', {
            token: token.value,
            email: email.value,
            password: password.value,
            password_confirmation: passwordConfirmation.value,
          })
          .then((response) => {
            if (response?.status === 200) {
              msg.value.success = true
              redirectTimer = setTimeout(() => router.push('/login'), 2500)
            }
          })
          .catch((error) => {
            const status = error?.response?.status
            const data = error?.response?.data

            if (status === 429) {
              msg.value.error = 'Muitas tentativas. Aguarde um minuto e tente novamente.'
            } else if (status === 422) {
              const fieldErrors = data?.errors ? Object.values(data.errors).flat() : []
              msg.value.error = data?.message && !fieldErrors.length
                ? data.message
                : (fieldErrors[0] || 'Não foi possível redefinir a senha.')
            } else {
              msg.value.error = 'Não foi possível redefinir a senha. Tente novamente em instantes.'
            }
          })
          .finally(() => {
            sending.value = false
          })
      }

      const goBack = () => {
        router.push('/login')
      }

      onBeforeUnmount(() => {
        if (redirectTimer) clearTimeout(redirectTimer)
      })

      return {
        email,
        hasLink,
        password,
        passwordConfirmation,
        sending,
        msg,
        onSubmit,
        goBack,
      }
    },
  }
</script>
